import FeedbackPage from '@/components/FeedbackPage'
import { getDealFeedback } from '@/utils/feedbackContent'

export default function DealbreaksFeedbackPage() {
  return <FeedbackPage {...getDealFeedback()} />
}
